// color is a chart colour token (@shared/modules/chart-colors)
export const SMS_STATISTICS_EVENT_TYPES = [
    { key: 'sent', contactType: 'Sent', color: 'eventSent' },
    { key: 'pending', contactType: 'Pending', color: 'eventPending' },
    { key: 'delivered', contactType: 'Delivered', color: 'eventReceived' },
    { key: 'clicked', contactType: 'Clicked', color: 'eventClicked' },
    { key: 'bounced', contactType: 'Bounced', color: 'eventBounced' },
] as const;

export function getSmsStatisticsLabelMap(): Record<string, string> {
    return {
        sent: $Resources.SmsSentLabel,
        pending: $Resources.SmsPendingLabel,
        delivered: $Resources.SmsReceivedPercentageLabel,
        clicked: $Resources.ClickedLabel,
        bounced: $Resources.SmsBouncedPercentageLabel,
    };
}

export function getSmsStatisticsContactListHeadings(): Record<string, string> {
    return {
        Sent: $Resources.StatisticsSmsContactListHeadingSent,
        Pending: $Resources.StatisticsSmsContactListHeadingPending,
        Delivered: $Resources.StatisticsSmsContactListHeadingReceived,
        Clicked: $Resources.StatisticsSmsContactListHeadingClicked,
        Bounced: $Resources.StatisticsSmsContactListHeadingBounced,
    };
}

export function getSmsStatisticsContactListDescriptions(): Record<string, string> {
    return {
        Sent: $Resources.StatisticsSmsContactListDescriptionSent,
        Pending: $Resources.StatisticsSmsContactListDescriptionPending,
        Delivered: $Resources.StatisticsSmsContactListDescriptionReceived,
        Clicked: $Resources.StatisticsSmsContactListDescriptionClicked,
        Bounced: $Resources.StatisticsSmsContactListDescriptionBounced,
    };
}
